/** Frustration signals and the grouped error inbox. */
const en = {
  frustration: {
    title: 'Frustration Signals',
    subtitle: 'Sessions ranked by rage clicks, dead clicks and errors.',
    kpi: {
      avg: 'Avg Frustration',
      high: 'High-Frustration',
      highSub: 'score ≥ 40',
      rage: 'Rage Clicks',
      dead: 'Dead Clicks',
      errors: 'Errors',
    },
    columns: {
      session: 'Session',
      frustration: 'Frustration',
      rage: 'Rage',
      dead: 'Dead',
      errors: 'Errors',
      duration: 'Duration',
      when: 'When',
      actions: 'Actions',
    },
    stat: {
      rage: 'Rage clicks',
      dead: 'Dead clicks',
      errors: 'Errors',
    },
    watchReplay: 'Watch replay',
    createTicket: 'Create ticket from this session',
    empty: 'No frustrated sessions in this range.',
    ranges: { d7: '7d', d30: '30d', d90: '90d', all: 'All' },
  },
  errors: {
    title: 'Errors',
    subtitle: 'JS, console and network errors grouped across every session.',
    kpi: {
      groups: 'Error groups',
      open: 'Open',
      occurrences: 'Total occurrences',
      byKind: 'Network / JS / Console',
    },
    tabs: { all: 'All', js: 'JS', console: 'Console', network: 'Network' },
    searchPlaceholder: 'Search message…',
    columns: {
      impact: 'Impact',
      error: 'Error',
      kind: 'Kind',
      project: 'Project',
      people: 'People',
      events: 'Events',
      lastSeen: 'Last seen',
    },
    severity: {
      critical: 'critical',
      high: 'high',
      medium: 'medium',
      low: 'low',
    } as Record<string, string>,
    peopleAcross: (people: number, sessions: number) =>
      `${people} people across ${sessions} sessions`,
    occurrences: 'Occurrences',
    emptyFiltered: 'No errors match this filter.',
    empty: 'No errors captured yet.',
    detail: {
      notFound: 'Error not found.',
      status: 'Status',
      statuses: {
        OPEN: 'Open',
        ACKNOWLEDGED: 'Acknowledged',
        RESOLVED: 'Resolved',
        IGNORED: 'Ignored',
      } as Record<string, string>,
      events: 'Events',
      affectedSessions: 'Affected sessions',
      firstSeen: 'First seen',
      lastSeen: 'Last seen',
      recent: 'Recent occurrences',
      columns: { when: 'When', user: 'User', url: 'URL', actions: 'Actions' },
      watch: 'Watch',
      ticket: 'Ticket',
    },
  },
};

const tr: typeof en = {
  frustration: {
    title: 'Zorlanma Sinyalleri',
    subtitle: 'Öfke tıklamaları, ölü tıklamalar ve hatalara göre sıralanan oturumlar.',
    kpi: {
      avg: 'Ort. zorlanma',
      high: 'Yüksek zorlanma',
      highSub: 'puan ≥ 40',
      rage: 'Öfke tıklamaları',
      dead: 'Ölü tıklamalar',
      errors: 'Hatalar',
    },
    columns: {
      session: 'Oturum',
      frustration: 'Zorlanma',
      rage: 'Öfke',
      dead: 'Ölü',
      errors: 'Hata',
      duration: 'Süre',
      when: 'Ne zaman',
      actions: 'İşlemler',
    },
    stat: {
      rage: 'Öfke tıklamaları',
      dead: 'Ölü tıklamalar',
      errors: 'Hatalar',
    },
    watchReplay: 'Kaydı izle',
    createTicket: 'Bu oturumdan talep oluştur',
    empty: 'Bu aralıkta zorlanma yaşanan oturum yok.',
    ranges: { d7: '7g', d30: '30g', d90: '90g', all: 'Tümü' },
  },
  errors: {
    title: 'Hatalar',
    subtitle: 'Tüm oturumlar genelinde gruplanmış JS, konsol ve ağ hataları.',
    kpi: {
      groups: 'Hata grubu',
      open: 'Açık',
      occurrences: 'Toplam görülme',
      byKind: 'Ağ / JS / Konsol',
    },
    tabs: { all: 'Tümü', js: 'JS', console: 'Konsol', network: 'Ağ' },
    searchPlaceholder: 'Mesaj ara…',
    columns: {
      impact: 'Etki',
      error: 'Hata',
      kind: 'Tür',
      project: 'Proje',
      people: 'Kişi',
      events: 'Olay',
      lastSeen: 'Son görülme',
    },
    severity: {
      critical: 'kritik',
      high: 'yüksek',
      medium: 'orta',
      low: 'düşük',
    },
    peopleAcross: (people: number, sessions: number) =>
      `${sessions} oturumda ${people} kişi`,
    occurrences: 'Görülme',
    emptyFiltered: 'Bu filtreye uyan hata yok.',
    empty: 'Henüz yakalanan hata yok.',
    detail: {
      notFound: 'Hata bulunamadı.',
      status: 'Durum',
      statuses: {
        OPEN: 'Açık',
        ACKNOWLEDGED: 'Görüldü',
        RESOLVED: 'Çözüldü',
        IGNORED: 'Yok sayıldı',
      },
      events: 'Olay',
      affectedSessions: 'Etkilenen oturum',
      firstSeen: 'İlk görülme',
      lastSeen: 'Son görülme',
      recent: 'Son görülmeler',
      columns: { when: 'Ne zaman', user: 'Kullanıcı', url: 'URL', actions: 'İşlemler' },
      watch: 'İzle',
      ticket: 'Talep',
    },
  },
};

export const signals = { en, tr };
